import { OptionProp } from '../OptionSelector.constant'
import classnames from 'classnames'

import styles from './imageOption.module.scss'
import { OptionContainer } from '../option-container/option-container'
import { transformImageSrc } from '@src/quince-components/src/atoms/image/image.utils'

const getOptionImageURL = (imgURL: string) => {
  imgURL = transformImageSrc(imgURL)
  const imageURL = new URL(imgURL.startsWith('http') ? imgURL : `https:${imgURL}`)
  imageURL.searchParams.append('w', '48')
  imageURL.searchParams.append('h', '48')
  imageURL.searchParams.append('fm', 'webp')
  return imageURL.toString()
}

type ImageOptionProps = {
  value: string
  displayName?: string
  imgURL?: string | null
  disabled?: boolean
  onChange?: (value: string) => void
} & Pick<OptionProp, 'isSelected' | 'isRound' | 'selectionSetId' | 'className'>

export const ImageOption = ({
  value,
  displayName,
  imgURL,
  isSelected,
  isRound,
  disabled,
  className,
  selectionSetId,
  onChange,
}: ImageOptionProps) => {
  return (
    <OptionContainer
      value={value}
      displayName={displayName}
      selectionSetId={selectionSetId}
      isSelected={isSelected}
      srOnly
      disabled={disabled}
      inputClassName={styles.input}
      labelClassName={classnames(className, styles.label, {
        [styles.isRound]: isRound,
      })}
      onChange={onChange}
    >
      <img
        className={classnames(styles.image)}
        src={imgURL ? getOptionImageURL(imgURL) : undefined}
        role="presentation"
      />
    </OptionContainer>
  )
}

const ImageOptionWithOptionValue = ({ optionValue, ...props }: OptionProp) => {
  return (
    <ImageOption
      value={optionValue.value}
      displayName={optionValue.displayName}
      imgURL={optionValue.imgURL}
      {...props}
    />
  )
}

export default ImageOptionWithOptionValue
